export const StickyOrderButtonBottom = () => {
  return (
    <button className="js__stickyButtonDouble js__stickyButtonBottomEdge stickyButton-double">
      { I18n.t('subscription.subscription') }
    </button>
  )
}
